export const DEFAULT_COUNT_GOOD = 1;
export const DEFAULT_GOOD_REST = 8;
export const NUMBER_REGEX = /\D/g;
